import _ from "lodash";
import React from "react";
import ToolTip from "../../../../parts/tooltip";

import getAvatarUrl from "../../../../utils/get-avatar-url";
import Avatar from "../../../../parts/avatar";
import CycleCard from "../../../../parts/cards/cycle-card";

const CycleCardCP = (props) => {
  const { cycle } = props;
  const isTemplate =
    cycle.owner._id === cycle.createdBy._id && cycle.type === "coach";
  const isSubscription =
    cycle.owner._id === cycle.createdBy._id && cycle.type === "subscription";
  const isSubscriptionPublished =
    isSubscription && cycle.status === "published";
  if (isTemplate || isSubscription) {
    return (
      <CycleCard
        {...props}
        isTemplate={isTemplate}
        isSubscription={isSubscription}
        isSubscriptionPublished={isSubscriptionPublished}
      />
    );
  }
  return (
    <div className="column" data-col="1/3">
      <div className="Coaching-Program-Card">
        <div
          className="image"
          style={{
            backgroundImage: `url("${getAvatarUrl(
              Object.assign({}, cycle.owner, { avatar: cycle.image })
            )}")`,
          }}
        ></div>

        <div className="details">
          <div className="name">{cycle.name}</div>
        </div>
        <ul className="programs">
          {cycle.programs.map((program) => (
            <li key={`${cycle._id}-${program.order}`}>
              <div className="Coaching-Program-Item">
                <div className="name">{program.name}</div>

                <ToolTip
                  id={`overview-${cycle._id}-${program.order}`}
                  body="Overview"
                >
                  <a
                    href={`/athlete-portal/programs/program-overview/${cycle._id}?referrer=program-builder&athlete=${cycle.owner._id}&program=${program.order}`}
                    className="overview-button"
                  >
                    <img src="/img/icons/overview.svg" alt="" />
                  </a>
                </ToolTip>

                <ToolTip
                  id={`send-program-${cycle._id}-${program.order}`}
                  body="Send Program"
                >
                  <a
                    href={`/actions/refresh/?modal[type]=send&cycleId=${cycle._id}&programOrder=${program.order}`}
                    className="copy-button"
                  >
                    <img src="/img/icons/copy.svg" alt="" />
                  </a>
                </ToolTip>
              </div>
            </li>
          ))}
        </ul>

        <div className="foot">
          <Avatar
            user={{
              name: _.get(cycle, "owner.name"),
              avatar: _.get(cycle, "owner.avatar"),
            }}
            size={32}
          />
          <div className="name">{_.get(cycle, "owner.name")}</div>
        </div>

        <div className="more">
          <div className="content">
            <a
              href={`/athlete-portal/programs/program-overview/${cycle._id}?referrer=program-builder&athlete=${cycle.owner._id}`}
            >
              <i className="icon">
                <img src="/img/icons/overview_white.svg" alt="" />
              </i>
              Overview
            </a>
            <a href={`/actions/refresh/?modal[type]=send&cycleId=${cycle._id}`}>
              <i className="icon">
                <img src="/img/icons/copy_white.svg" alt="" />
              </i>
              Send Cycle
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CycleCardCP;
